<template>
  <div class="container" v-if="$store.state.display_width <= 768 || $store.state.display_width > 1024">
    <div class="bread-crumbs">
      <router-link to="/">
        <img src="@/assets/img/svg/breadCrumbs.svg" alt="bread crumbs">
      </router-link>
      <router-link v-for="page in $route.matched" :key="page.name" :to="page.path" class="bread-crumbs__container">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 6L1 11" stroke="#8A8887" stroke-width="1.5"/>
        </svg>
        {{ page.meta.pageName }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbs'
}
</script>

<style scoped lang="scss">
.bread-crumbs {
  display: flex;
  margin-top: rem(24);
  margin-bottom: rem(40);
  width: rem(599);
}

.container {
  overflow: hidden;
}

svg {
  margin-left: rem(14);
  margin-right: rem(13);
}

.bread-crumbs__container {
  color: #8A8887;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.01em;
}

@media (max-width: em(768, 16)) and (min-width: em(320, 16)) {

  .bread-crumbs {
    width: calc(25rem + (599 - 400) * ((100vw - 20rem) / (768 - 320)));
    display: flex;
    align-items: center;
    margin-top: calc(0.5rem + (24 - 8) * ((100vw - 20rem) / (768 - 320)));
    margin-bottom: calc(1.5rem + (40 - 24) * ((100vw - 20rem) / (768 - 320)));
  }
  .bread-crumbs__container {
    font-size: calc(0.625rem + (16 - 10) * ((100vw - 20rem) / (768 - 320)));
  }
  svg {
    margin-left: calc(0.5rem + (14 - 8) * ((100vw - 20rem) / (768 - 320)));
    margin-right: calc(0.5rem + (13 - 8) * ((100vw - 20rem) / (768 - 320)));
  }
}

@media (max-width: em(319, 16)) and (min-width: em(220, 16)) {
  .bread-crumbs {
    width: calc(23.75rem + (400 - 380) * ((100vw - 13.75rem) / (319 - 220)));
  }
}

@media (max-width: em(319, 16)) {
  .container {
    overflow: hidden;
  }
  .bread-crumbs {
    margin-top: rem(8);
    margin-bottom: rem(24);
    display: flex;
    align-items: center;
  }
  .bread-crumbs__container {
    font-size: rem(10);
  }
  svg {
    margin-left: rem(8);
    margin-right: rem(8);
  }
}
</style>